import React, { useEffect, useState } from "react";
import { FaArrowRight, FaCheck, FaCheckCircle } from "react-icons/fa";
import { Toast, Badge, Button } from "Components";
import { get } from "Utils/axios";

function SubscriptionPlans({ selected, buttonLabel = "Verify Your Email", country, loading = false, error = "", onSubmit = () => {}, onCancel = () => {} }) {
	const [SelectedPlan, setSelectedPlan] = useState(selected);
	const [Plans, setPlans] = useState({});

	useEffect(() => {
		fetchPlans();
	}, []);

	const handleSubmit = () => {
		if (!SelectedPlan) {
			Toast.error("Please select a plan");
			return;
		}
		onSubmit(SelectedPlan);
	};

	const fetchPlans = async () => {
		get(`/plans/${country}`, {}, (res) => {
			const plans = {
				BASIC: res.find((plan) => plan.name === "BASIC"),
				PREMIUM: res.find((plan) => plan.name === "PREMIUM"),
				ENTERPRISE: res.find((plan) => plan.name === "ENTERPRISE"),
			};
			setPlans(plans);
		});
	};

	return (
		<div className="flex flex-col items-center justify-center h-full text-center gap-y-8 md:gap-y-10 fade-in-up">
			<div>
				<h1 className="text-2xl font-bold md:text-4xl">Choose Your Monthly Plan</h1>
				<div className="mt-2 text-sm font-thin md:text-xl">We will not charge you anything for now, you can cancel anytime.</div>
			</div>
			<div className="grid w-full max-w-6xl grid-cols-1 gap-4 mx-auto mt-6 md:mt-8 md:grid-cols-3 md:gap-4">
				{Object.values(Plans).map(({ name, subscription, perBooking, currency, teamSize, description }) => {
					return (
						<div
							key={name}
							onClick={() => setSelectedPlan(name)}
							className={`relative border rounded-xl p-4 md:p-6 flex-grow hover:bg-light cursor-pointer ${
								SelectedPlan === name ? "ring-2 ring-primary" : ""
							}`}
						>
							<h1 className="text-2xl uppercase md:text-3xl">{name}</h1>
							<h1 className="mt-2 text-base md:text-lg">
								{currency} {subscription}
							</h1>
							{!isNaN(subscription) && (
								<p className="mt-2 text-xs opacity-70 md:text-sm">
									Service charge {currency} {perBooking} per booking
								</p>
							)}
							<Badge variant="info" className="mt-2">
								{teamSize}
							</Badge>
							<ul className="flex flex-col mt-4 text-xs text-left text-secondary gap-y-2 md:mt-6 md:text-sm">
								{[...description?.matchAll(/^h\d+\.\s*(.+)$/gm)]
									?.map((match) => match[1])
									.map((item) => (
										<li className="flex">
											<FaCheck className="mt-1 mr-2" />
											{item}
										</li>
									))}
							</ul>
							{SelectedPlan === name && <FaCheckCircle className="absolute w-6 h-6 top-4 left-4 text-primary" />}
						</div>
					);
				})}
			</div>
			{error && (
				<Badge variant="warning" className="mt-4 !text-base">
					{error}
				</Badge>
			)}
			<div className="flex flex-col mx-auto mt-6 gap-3 md:flex-row md:mt-8 md:gap-x-4">
				<Button loading={loading} onClick={handleSubmit} variant="primary">
					{buttonLabel} <FaArrowRight className="ml-2" />
				</Button>
				<Button onClick={onCancel} variant="secondary">
					Cancel
				</Button>
			</div>
		</div>
	);
}

export default SubscriptionPlans;
